import { F0Dialog } from '@factorialco/f0-react'
import {
  AtsJobApplicationHeaderDocument,
  AtsUnassignVacancyFromJobApplicationDocument,
  AtsUnassignVacancyFromJobApplicationMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  vacancyId: string
  onClose: () => void
}

export const UnassignVacancyConfirmModal = ({ vacancyId, onClose }: Props) => {
  const [unassignVacancy, { loading, client }] = useMutation(
    AtsUnassignVacancyFromJobApplicationDocument,
    {
      extractorFn: (result: AtsUnassignVacancyFromJobApplicationMutation) =>
        result.atsMutations.unassignApplicationAtsVacancy,
    }
  )

  const handleUnassign = async () => {
    const result = await unassignVacancy({
      variables: { id: vacancyId },
    })

    const handled = handleResult(result, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('ats.application_details.header.unassign_vacancy.error_message'),
      })
    })

    if (handled.success) {
      void client.refetchQueries({ include: [AtsJobApplicationHeaderDocument] })
      app.setFlash({
        type: 'correct',
        message: i18n.t('ats.application_details.header.unassign_vacancy.success_message'),
      })
    }

    onClose()
  }

  return (
    <F0Dialog
      title={i18n.t('ats.application_details.header.unassign_vacancy.title')}
      isOpen
      onClose={onClose}
      primaryAction={{
        label: i18n.t('ats.application_details.header.unassign_vacancy.confirm_button'),
        onClick: handleUnassign,
        disabled: loading,
        variant: 'danger',
      }}
      secondaryAction={{
        label: i18n.t('ats.application_details.header.unassign_vacancy.cancel_button'),
        onClick: onClose,
      }}
    >
      {i18n.t('ats.application_details.header.unassign_vacancy.description')}
    </F0Dialog>
  )
}
